import {
  GroupModel,
  GroupModelAttributes,
  GroupModelCreateAttributes,
  GroupModelUpdateAttributes,
  GroupCollection,
  GroupsAttributesAndResourcesAttributes,
} from 'src/models/GroupModel';
import { Notify } from 'quasar';
import {
  GroupAdapterInteface,
  ListGroupsInput as BaseListGroupsInput,
} from 'src/adapter/GroupAdapterInterface';
import { apiErrorHandler } from 'src/error/handler/apiErrorHandler';
export type ListGroupsInput = BaseListGroupsInput;
export class GroupApiClass {
  adapter: GroupAdapterInteface;
  constructor(adapter: GroupAdapterInteface) {
    this.adapter = adapter;
  }
  async getTopGroups(group_type_id: string): Promise<GroupCollection> {
    try {
      const res = await this.adapter.getTopGroups(group_type_id);
      // TODO APIが空配列を返すようになったらif文削除
      if (res.data) {
        return res.data.map(
          (group: GroupModelAttributes) => new GroupModel(group)
        );
      }
      return [];
    } catch (e) {
      throw apiErrorHandler(e);
    }
  }
  async listGroups(
    conditions: ListGroupsInput
  ): Promise<{ total: number; data: GroupCollection }> {
    try {
      const res = await this.adapter.listGroups(conditions);
      return {
        total: res.total,
        data: res.data.map(
          (group: GroupModelAttributes) => new GroupModel(group)
        ),
      };
    } catch (e) {
      throw apiErrorHandler(e);
    }
  }
  async getGroup(id: string): Promise<GroupModel> {
    try {
      const group = await this.adapter.getGroup(id);
      return new GroupModel(group);
    } catch (e) {
      throw apiErrorHandler(e);
    }
  }
  async createGroup(
    attributes: GroupModelCreateAttributes
  ): Promise<GroupModel> {
    try {
      const group = await this.adapter.createGroup(attributes);
      Notify.create({
        type: 'positive',
        message: '作成しました',
      });
      return new GroupModel(group);
    } catch (e) {
      throw apiErrorHandler(e);
    }
  }
  async updateGroup(
    id: string,
    attributes: GroupModelUpdateAttributes
  ): Promise<GroupModel> {
    try {
      const group = await this.adapter.updateGroup(id, attributes);
      Notify.create({
        type: 'positive',
        message: '更新しました',
      });
      return new GroupModel(group);
    } catch (e) {
      throw apiErrorHandler(e);
    }
  }
  async deleteGroup(id: string): Promise<boolean> {
    try {
      const res = await this.adapter.deleteGroup(id);
      Notify.create({
        type: 'positive',
        message: '削除しました',
      });
      return res;
    } catch (e) {
      throw apiErrorHandler(e);
    }
  }
  async getChildsByGroupId(
    id: string
  ): Promise<GroupsAttributesAndResourcesAttributes> {
    try {
      return await this.adapter.getChildsByGroupId(id);
    } catch (e) {
      throw apiErrorHandler(e);
    }
  }
}
